import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getDashBoardGameSuccess,
  getDashBoardGameFailed,
  GET_DASHBOARD_GAME_START,
} from '../../actions/dashboard'

/**
 * get dashBoard bit api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getDashBoardGameApi = (props) => {
  var uri = `/admin/dashboard/bi-daily`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDashBoardTrade(action) {
  try {
    const response = yield call(getDashBoardGameApi, action?.payload)
    if (response?.statusCode !== 400) {
      yield put(getDashBoardGameSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
    } else {
      throw response?.message
    }
  } catch (error) {
    yield put(getDashBoardGameFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get dashBoard bit
 */
export default function* watchGetDashBoardGame() {
  yield takeLatest(GET_DASHBOARD_GAME_START, doGetDashBoardTrade)
}
